module.exports = '/ng-templates/modals/loan-ready-notice-to-send-question-modal/loan-ready-notice-question-to-send-modal.tpl.ftl';
